import React, { useMemo } from 'react';
import { BarChart } from '@aidkitorg/component-library';
import { SupportedDashboardComponent, DashboardComponentResult } from '@aidkitorg/types/lib/admin-panel/dashboard';
import { processBarChartData } from './barChartDataUtils';
import { createValueFormatter } from '../../../../DistroDashboard/ChartTools';

type AdminPanelBarChartProps = {
  component: SupportedDashboardComponent & { kind: 'Bar Chart' };
  queryResult: DashboardComponentResult;
  height?: number;
  tableCaption?: string;
};

export const AdminPanelBarChart: React.FC<AdminPanelBarChartProps> = ({
  component,
  queryResult,
  height = 300,
  tableCaption,
}) => {
  const { processedData, categoryKey, valueKey } = useMemo(() => {
    const result = processBarChartData({ component, queryResult });
    return {
      processedData: result.processedData,
      categoryKey: result.primaryGroupField,
      valueKey: result.valueKeys.length === 1 ? result.valueKeys[0] : result.valueKeys,
    };
  }, [component, queryResult]);

  const valueFormatter = useMemo(() => createValueFormatter(component.numberFormat), [component.numberFormat]);

  return (
    <BarChart
      data={processedData}
      categoryKey={categoryKey}
      valueKey={valueKey}
      xAxisLabel={component.xAxisLabel}
      yAxisLabel={component.yAxisLabel}
      height={height}
      tableCaption={tableCaption}
      showPercentages={component.showPercentages === true}
      showBarLabels={component.showBarLabels === true}
      stack={component.bars?.kind === 'Stacked'}
      valueFormatter={valueFormatter}
      suffix={component.units}
    />
  );
};
